<!-- padding: getSidePadding(), -->
<div
class="main-grid"
[ngStyle]="{
  'column-gap': columnGap,
    'grid-template-rows': getRowsConfig(),
    'grid-template-columns': getTotalColumns(),
    'background-color': backgroundColor,
  }"
>
  <ng-content></ng-content>
</div>
